import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Translate, I18n } from 'react-redux-i18n'
import * as API from '../../utility/api'

const formatDate = date => {
  if (!date) return ''

  return moment(date).format('DD.MM.YYYY')
}

const SearchAlerts = () => {
  const [searchAlerts, setSearchAlerts] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [filterValue, setFilterValue] = useState('')

  useEffect(() => {
    setLoading(true)
    setError(false)

    API.GET('admin/subscriptions/active')
      .then(({ data }) => {
        setSearchAlerts(data.search_alerts || [])
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }, [])

  const filteredSearchAlerts = useMemo(() => {
    const normalizedFilter = filterValue.trim().toLowerCase()

    if (!normalizedFilter) {
      return searchAlerts
    }

    return searchAlerts.filter(searchAlert => {
      const visibleText = [
        searchAlert.name,
        formatDate(searchAlert.start_date),
        searchAlert.city,
        searchAlert.organizer,
        String(searchAlert.search_alert_count),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()

      return visibleText.includes(normalizedFilter)
    })
  }, [filterValue, searchAlerts])

  if (loading) {
    return <div>{I18n.t('search_alerts.loading')}</div>
  }

  if (error) {
    return <div>{I18n.t('search_alerts.loading_error')}</div>
  }

  const hasFilter = filterValue.trim().length > 0
  const showEmptyState = searchAlerts.length === 0
  const showFilteredEmptyState =
    searchAlerts.length > 0 && filteredSearchAlerts.length === 0

  return (
    <div>
      <h2>
        <Translate value="search_alerts.admin_title" />
      </h2>

      <div className="search-alerts-toolbar">
        <input
          type="text"
          className="search-alerts-filter-input"
          value={filterValue}
          onChange={e => setFilterValue(e.target.value)}
          placeholder={I18n.t('search_alerts.filter_placeholder')}
        />
        <button
          type="button"
          className="search-alerts-clear-button"
          onClick={() => setFilterValue('')}
          disabled={!hasFilter}
          aria-label={I18n.t('search_alerts.clear_filter')}
        >
          x
        </button>
      </div>

      {showEmptyState && (
        <div className="search-alerts-empty-state">
          <Translate value="search_alerts.admin_empty" />
        </div>
      )}

      {showFilteredEmptyState && (
        <div className="search-alerts-empty-state">
          <Translate value="search_alerts.admin_filtered_empty" />
        </div>
      )}

      {filteredSearchAlerts.length > 0 && (
        <table className="tl-event-table search-alerts-table">
          <thead>
            <tr>
              <th className="tl-event-table__column--l">
                <Translate value="search_alerts.event_name" />
              </th>
              <th className="tl-event-table__column--l">
                <Translate value="search_alerts.date" />
              </th>
              <th className="tl-event-table__column--l">
                <Translate value="search_alerts.city" />
              </th>
              <th className="tl-event-table__column--l">
                <Translate value="search_alerts.organizer" />
              </th>
              <th className="tl-event-table__column--r">
                <Translate value="search_alerts.number_of_alerts" />
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredSearchAlerts.map(searchAlert => (
              <tr key={`admin-search-alert-${searchAlert.event_id}`}>
                <td className="tl-event-table__column--l">
                  <Link to={`/events/${searchAlert.event_id}`}>
                    {searchAlert.name}
                  </Link>
                </td>
                <td className="tl-event-table__column--l">
                  {formatDate(searchAlert.start_date)}
                </td>
                <td className="tl-event-table__column--l">
                  {searchAlert.city}
                </td>
                <td className="tl-event-table__column--l">
                  {searchAlert.organizer}
                </td>
                <td className="tl-event-table__column--r">
                  {searchAlert.search_alert_count}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default SearchAlerts
